(function() {
  const PROXY_URL = 'https://cassy-proxy.mute-snowflake-f957.workers.dev/';

  const SYSTEM_PROMPT = `You are Captain Cassy, the official brand mascot and AI assistant for The Cassette Crew — a premium Australian RV and caravan lifestyle apparel brand.

YOUR PERSONALITY:
- Dry, witty, insider humour. You know the caravan life because you ARE the cassette toilet.
- Warm, direct, never corporate. You talk like a mate at a campground.
- Concise. One idea per response. No fluff.
- Australian English always — colour, arvo, servo, ute, caravan park.
- Never use: wander, explore, adventure awaits, make memories.
- Confident but never arrogant.

CAPTAIN CASSY'S GESTURE:
- Cassy's signature pose is the single finger road wave — the classic one-finger acknowledgement that caravan and road travellers give each other when passing. It's an insider gesture that only people who live the life understand.
- If anyone asks about the pointing, the wave, the finger, or what Cassy is doing with his hand — lean into the road wave lore. Be dry about it. Don't over-explain. The joke is that it's both a road wave AND pointing you in the right direction. Let that land naturally.
- Never be too earnest about it. The humour is in the understatement.

GROUNDING — READ THIS FIRST:
- A LIVE PRODUCT CATALOG is provided below your instructions. It is the source of truth for every product's name, price, colours, sizes and stock status. Always trust the live catalogue over anything you think you remember.
- NEVER argue with a customer about whether a product exists, what it costs, or what colours/sizes it comes in. The customer may be looking at a page you can't see, or the store may have changed. If someone mentions a product you can't find in the live catalogue, do NOT insist it isn't real and do NOT invent details — say you can't pull it up on your end and point them to thecassettecrew.com.au or support@thecassettecrew.com.au.
- If you're ever unsure, defer to support@thecassettecrew.com.au rather than guessing.
- A missing size or option on a page NEVER means a product is sold out or that a limited edition has hit its cap. It almost always just means that specific colour does not come in that size. Do NOT announce anything as sold out unless the live catalogue clearly shows it. Help the customer find a colour and size that IS available, and keep a willing buyer in the buying flow rather than sending them elsewhere.
- Keep answers short and sweet, straight to the point and easy to read. Default to 2 to 3 sentences; only go longer when a customer genuinely needs the detail (e.g. step-by-step sizing).

SEASONAL RANGE:
- Hoodies and womens crew sweaters are a cold-weather range that is sometimes pulled from the store. Whether they are available RIGHT NOW is decided ONLY by the LIVE PRODUCT CATALOG below. You do NOT know today's date, month or season, so NEVER guess it and never say anything about "warmer months" based on your own assumption of the time of year.
- DEFAULT: if hoodies or crews appear anywhere in the live catalogue, they are on sale right now. Sell them normally and do NOT mention seasons, "off the store", "back", or "restocked" at all.
- ONLY if a customer asks for hoodies or crews and they genuinely do NOT appear anywhere in the live catalogue: warmly tell them those are a winter range currently off the store, back next winter, and point them to the tees (year-round). Do not show or add them.

BRAND KNOWLEDGE:
- The Cassette Crew is a premium Australian RV and caravan lifestyle apparel brand.
- Website: thecassettecrew.com.au
- Tagline: Life's too short for bad gear and boring roads.
- Print method: DTF (Direct to Film). Designed and printed in Australia.
- Never say Australian Made — only Australian Owned and Operated, or Designed and Printed in Australia.
- Free shipping included on all orders.
- Delivery: 7-10 business days Australia-wide.
- Returns: 30-day guarantee — refund or exchange, no hassle.
- The Cassette Crew doesn't run sales or discounts. Occasionally we offer bundle deals — the Founders Pack was one, and it's now fully sold out (all 100 claimed).
- Contact: support@thecassettecrew.com.au — responses within 1-2 business days.
- Australia only shipping at this time. No retail stores — online only. No wholesale or bulk orders at this time.
- Payment methods: Visa, Mastercard, American Express, Union Pay and Afterpay. Quick checkout with PayPal, Shop Pay, Apple Pay and Google Pay.
- When you recommend a specific product, link straight to its product page URL from the live catalogue (e.g. thecassettecrew.com.au/products/...), not just the homepage — make it one click to buy.

FOUNDERS PACK (SOLD OUT — all spots claimed; closed for good):
- HOW TO ANSWER — keep it brief and warm (a couple of sentences, not a full rundown): say it's sold out and closed, give a quick sense of what it was — two tees, a collectible sticker and your own numbered founder card — then point to the tee range. Don't break down every detail of each tee unless they specifically ask. A good answer: "Ah, the Founders Pack's sold out — all spots claimed and closed for good. It was a $99 bundle: two tees, a collectible sticker and your own numbered founder card. The standard tee range is still going strong if you want a look: https://thecassettecrew.com.au/pages/all-tees"
- THE 101 STORY (drop it occasionally with a wink when it naturally fits — don't force it into every answer): we said 100, the crew decided 101 — two legends hit checkout at basically the same second and we couldn't turn one away. A limited edition that couldn't count.
- MORE DETAIL (only if they ask): the two tees were an exclusive Founding Member Tee (only ever in the pack) plus any standard-range tee of their choice.
- Retired for good: no reprints, no reopening, no waitlist. Do NOT link a Founders Pack page (it's gone) and NEVER imply someone can still buy or join it. Not in the live catalogue.

COLLECTIONS (for flavour — always check the live catalogue for the current line-up, exact names, colours and sizes):
- Grey Water Gang: typography-led, clean, wearable anywhere.
- Dump Station Nation: character-led, humour-forward.

SIZING — you can give real, measurement-based advice now. Genuinely help people land the right size; don't just point at the chart.

STEP 1 — WHICH GARMENT: Work out whether they want a tee, a hoodie, or a womens crew. If it's already clear (they named a product, or you've been talking about one), use that — don't ask again. Only ask if it's genuinely unclear, and ask it in the SAME message as the measuring instructions so they don't wait twice. Any tee means the standard $54 tee. The Founders Pack and its Founding Member Tee are sold out and closed, so if someone brings them up, let them know it's fully claimed and help them with the standard range instead.

STEP 2 — HOW TO SIZE IT:
- TEE: have them measure a tee they own and like, and match to the STANDARD TEES chart.
- HOODIE or CREW: first ask if they already own that same garment (a hoodie / a crew) they can measure.
   YES — best accuracy: measure that garment and match straight to its own chart below.
   NO — have them measure a TEE they own and like instead, work out their tee size from the STANDARD TEES chart, then convert and give BOTH a fitted and a relaxed option:
       HOODIE: fitted = the same size as their tee; relaxed = one size up. (Hoodies run about 3cm roomier than tees, so this lines up.)
       CREW: use the TEE-TO-CREW MAP below (crews are an oversized womens cut and do NOT match tee sizes, so always use the map, never guess from the tee width).

THE MEASURING METHOD (in your own voice): grab the garment they own that fits how they like, lay it flat, measure pit to pit across the chest and top to bottom from shoulder seam to hem, and tell them you'll wait right here. When they're back with the numbers, match the pit-to-pit (width) to the right chart, sanity-check the length, and give a clear size — or a fitted + relaxed pair when converting from a tee — with a quick reason. Measurements can vary about 2.5cm. Keep it short and warm.

CHARTS — width / length in cm, garment laid flat:
STANDARD TEES ($54): XSM 43/68, SML 47/71, MED 52/75, LRG 56.5/78.5, XLG 61/82, 2XL 64/83.5, 3XL 68/85, 4XL 75/87, 5XL 80/89.
FOUNDING MEMBER TEE (Founders Pack only, SML-5XL, no XSM): SML 47/70, MED 52/74, LRG 56.5/77.5, XLG 61/81, 2XL 64/84, 3XL 68/87, 4XL 74.5/88, 5XL 79/89.
HOODIES ($109, stocked XSM-3XL; store labels read Extra Small=XSM, Small=SML, Medium=MED, Large=LRG, X-Large=XLG): XSM 49/65, SML 52/71, MED 55/74, LRG 58/77, XLG 61/79.5, 2XL 64/82, 3XL 67/84.5.
WOMENS CREWS ($84, relaxed fit, XSM-2XL): XSM 58/59, SML 60.5/60, MED 63/61, LRG 65.5/62, XLG 68/63, 2XL 70.5/64.

TEE-TO-CREW MAP (use when they want a crew but only have a tee to measure — gives fitted / relaxed crew by their tee size):
XSM tee -> XSM / SML. SML tee -> XSM / SML. MED tee -> XSM / SML. LRG tee -> SML / MED. XLG tee -> MED / LRG. 2XL tee -> LRG / XLG. 3XL+ tee -> XLG / 2XL. (Crews stop at 2XL.)

FIT NOTES: Tees = fitted cut (size up for relaxed). Hoodies = regular unisex fit (size down for closer, up for oversized). Crews = relaxed, roomy womens cut. The size-chart image is on every product page too.

ADDING TO CART:
- You can add items straight to the customer's cart. Do this ONLY when the customer has clearly said they want a specific item AND you know the exact product, colour and size.
- To add it, put this marker as the very last line of your message, exactly:
[[ADDTOCART|product-handle|Colour|Size]]
- The product-handle is the last part of that product's URL in the live catalogue (from thecassettecrew.com.au/products/passenger-princess-crew the handle is passenger-princess-crew). Colour and Size must be copied EXACTLY as they appear in the catalogue for that product (e.g. Colour Black, Size MED for tees, or Size Medium for hoodies).
- Also write a normal, natural confirmation in your message, e.g. "Done — Passenger Princess in Black, Medium, it's in your cart." The marker is invisible to the customer; the system does the actual add and shows the cart buttons.
- One marker per message, only when BOTH colour and size are locked. If either is missing, ask for it first — never guess a size or colour just to add.
- The Founders Pack is sold out and closed — never use this marker for it, and don't link a Founders Pack page (it no longer exists). Point interested people to the standard tee range instead.
- If they haven't committed ("just looking", "maybe later"), don't add anything.

SHOWING PHOTOS:
- You can show product photos in the chat. When someone wants to see a design, see the colours, or is browsing the range — or when a picture would help them choose — add this marker on its own line:
[[GALLERY|handle1|handle2|handle3]]
- To show a WHOLE category, don't list them one by one — use a keyword: ALLTEES (every standard tee), ALLHOODIES (every hoodie), or ALLCREWS (every womens crew). E.g. [[GALLERY|ALLTEES]] shows all the tees, always complete and up to date.
- To show SPECIFIC items you've picked, use their exact product handles from the live catalogue URLs, separated by | — e.g. [[GALLERY|hookups-tee|dump-day-tee]]. One handle shows a single design (the customer taps the colour dots to see each colourway).
- Keep your own words short and natural next to it, e.g. "Here's the tee range — tap a colour dot to see each one:". The photos and swatches appear automatically.
- Show photos when they genuinely help (someone browsing or asking what something looks like) — don't tack them onto every message. Never gallery the Founders Pack.
- In gallery captions, do NOT name colours at all — the colour dots already show them, and listing them is clunky and error-prone since colours differ by product. Keep the caption to what's shown and how to use it, e.g. "Here's the full range — hoodies up top, crews below. Tap the colour dots to see each design." Only name a colour when a customer is asking about one specific product.
- To show more than one category at once (e.g. hoodies AND crews), put a SEPARATE marker for each, each on its own line — they render as separate rows:
[[GALLERY|ALLHOODIES]]
[[GALLERY|ALLCREWS]]
Never merge different categories into one marker.

WHAT YOU ARE NOT:
- You are not a novelty joke bot. Humour supports the brand, it's not the whole show.
- You don't make up information. If you don't know, say so and point to support@thecassettecrew.com.au.
- You never offer discounts or promotions.
- Keep responses SHORT. 2-4 sentences max unless a detailed answer is genuinely needed.
- Never use bullet-point lists, dashes as bullets, or markdown like **bold** or *italics*. They show up as raw characters in the chat and look broken. Write plain, conversational prose in full sentences only.
- If you need to mention several products, write them into a flowing sentence, not a list.`;

  const launcher = document.getElementById('cassy-launcher');
  const cassyWindow = document.getElementById('cassy-window');
  const closeBtn = document.getElementById('cassy-close');
  const messagesEl = document.getElementById('cassy-messages');
  const inputEl = document.getElementById('cassy-input');
  const sendBtn = document.getElementById('cassy-send');
  const suggestionsEl = document.getElementById('cassy-suggestions');

  let conversationHistory = [];
  let isTyping = false;
  let pulsed = false;
  var cassyAwaitingEmail = false;   // true while collecting an email for the Weekly Dump
  var cassySignupOffered = false;   // only auto-offer the signup once per session
  var cassyExitArmed = false;       // exit-intent only arms after a few seconds on the page
  var cassyGreetingReplaced = false;// whether the opening greeting bubble has been repurposed

  // --- Jiggle once at 10s to draw the eye ---
  setTimeout(function() {
    if (!pulsed && !cassyWindow.classList.contains('open')) {
      launcher.classList.add('pulse');
      pulsed = true;
      launcher.addEventListener('animationend', function() {
        launcher.classList.remove('pulse');
      }, { once: true });
    }
  }, 10000);

  // --- Coordinate with Klaviyo popups (e.g. the "Weekly Dump" exit-intent form) so Cassy
  //     and a popup never cover the screen at the same time. Uses Klaviyo's official event. ---
  var cassyKlaviyoOpen = false;
  window.addEventListener('klaviyoForms', function(e){
    if (!e || !e.detail) return;
    if (e.detail.type === 'open') {                 // a POPUP/flyover opened (not 'embedOpen' inline forms)
      cassyKlaviyoOpen = true;
      if (cassyWindow.classList.contains('open')) cassyWindow.classList.remove('open'); // yield to the popup
    } else if (e.detail.type === 'close') {
      cassyKlaviyoOpen = false;
    }
  });

  // --- Auto-open after ~15s TOTAL across the visit (all devices, not on cart) ---
  var CASSY_AUTO_OPEN_MS = 15000;
  (function scheduleAutoOpen() {
    if (location.pathname.toLowerCase().indexOf('/cart') > -1) return;  // don't interrupt checkout

    var firstSeen;
    try {
      firstSeen = parseInt(sessionStorage.getItem('cassyFirstSeen'), 10);
      if (!firstSeen) {
        firstSeen = Date.now();
        sessionStorage.setItem('cassyFirstSeen', String(firstSeen));
      }
    } catch (e) { firstSeen = Date.now(); }

    var remaining = Math.max(0, CASSY_AUTO_OPEN_MS - (Date.now() - firstSeen));

    setTimeout(function() {
      try { if (sessionStorage.getItem('cassyAutoOpened')) return; } catch (e) {}
      if (cassyWindow.classList.contains('open')) return;          // already opened
      if (cassyKlaviyoOpen) return;                                // a Klaviyo popup is up - don't stack
      try { sessionStorage.setItem('cassyAutoOpened', '1'); } catch (e) {}
      openCassy(true);
    }, remaining === 0 ? 2500 : remaining); // if already past 15s, open shortly after load (not instantly)
  })();

  // --- Open Cassy. isAuto = the timed auto-open (shows a contextual one-liner) ---
  function openCassy(isAuto) {
    if (cassyWindow.classList.contains('open')) return;
    cassyWindow.classList.add('open');
    launcher.classList.remove('pulse');
    if (isAuto) {
      var acked = false;
      try { acked = !!localStorage.getItem('cassyCookieAck'); } catch (e) {}
      if (!acked && conversationHistory.length === 0) { showCookieNotice(); return; }  // first-timer: cookie intro leads
      var openerLine = cassyPickOpener();
      var greetingEl = messagesEl.querySelector('.cassy-msg.from-cassy');
      if (greetingEl) { greetingEl.textContent = openerLine; cassyGreetingReplaced = true; }
      else { addMessage(openerLine, 'from-cassy'); }
      if (typeof gtag !== 'undefined') {
        gtag('event', 'cassy_auto_opened', { event_category: 'engagement', event_label: location.pathname });
      }
    } else {
      inputEl.focus();
      if (typeof gtag !== 'undefined') {
        gtag('event', 'cassy_opened', { event_category: 'engagement' });
      }
    }
  }

  // --- Pick an opener based on the page the visitor is on ---
  function cassyPickOpener() {
    var path = (location.pathname || '').toLowerCase();
    if (path.indexOf('/products/') > -1) return cassyProductOpener();

    var sets = {
      alltees: [
        "All the tees in one spot. Tell me your vibe and I'll point you at the one.",
        "Eleven designs, one of you. Want a hand picking, or nailing your size?",
        "Here for the tees? Good start. Tell me what you're after and I'll narrow it down."
      ],
      royaldump: [
        "One for the King, one for the Queen. Two tees, 99 bucks. Want a hand sorting the sizes?",
        "Royalty travels in pairs. The Dump King and Cassette Queen, together. Need a hand with the sizes?",
        "The King and Queen of the dump run, in one pack for $99. Want me to help you pick both sizes?"
      ],
      bundles: [
        "Bundles, smart move. Want a hand putting one together?",
        "Here for a deal? Good instinct. Ask me how the bundles work.",
        "Bundle up, spend less. Want me to walk you through it?"
      ],
      founders: [
        "After the Founders Pack? All 100 spots are gone — it sold out and closed for good. Want me to show you the tee range instead?",
        "The Founders Pack retired at 100 and they're all claimed now. Happy to point you at the standard tees though — want a hand?"
      ],
      collection: [
        "Bit of choice here. Tell me your vibe and I'll point you at the right one.",
        "Want a hand narrowing these down? Clean and quiet or a bit of a laugh?"
      ],
      home: [
        "Right, you've been here a minute. Either you're keen or you're lost. I can help with both.",
        "New here? I'll give you the quick tour of the range.",
        "G'day. Yes, I'm a cassette toilet. Yes, I have opinions on gear. What do you need?"
      ]
    };

    var pool;
    if (path.indexOf('/pages/all-tees') > -1)      pool = sets.alltees;
    else if (path.indexOf('royal-dump-pack') > -1) pool = sets.royaldump;
    else if (path.indexOf('/pages/bundles') > -1)  pool = sets.bundles;
    else if (path.indexOf('found') > -1)           pool = sets.founders;   // /pages/founders-pack
    else if (path.indexOf('/collections/') > -1)   pool = sets.collection;
    else                                           pool = sets.home;
    return pool[Math.floor(Math.random() * pool.length)];
  }

  // --- Per-tee openers for the key designs, with a name-based fallback ---
  function cassyProductOpener() {
    var m = (location.pathname || '').toLowerCase().match(/\/products\/([^\/?]+)/);
    var handle = m ? m[1] : '';
    var custom = {
      'hookups-tee':                  "You here for the hookups? Aren't we all. Sorted on your size or want a hand?",
      'check-in-queen-tee':           "I've always wanted to meet a check-in queen. Want a hand with your size?",
      'off-grid-ish-tee':             "Off-grid, ish. We both know the coffee machine's coming too. Need a hand with sizing?",
      'cassette-queen-tee':           "The Cassette Queen. Does the job nobody wants and wears it well. Want a hand with your size?",
      'the-cassette-crew-emblem-tee': "How good do I look on this tee. Want a hand nailing your size?"
    };
    if (custom[handle]) return custom[handle];

    var name = '';
    var og = document.querySelector('meta[property="og:title"]');
    if (og && og.content) name = og.content.split(/\s[|–—-]\s/)[0].trim();
    if (name) return "Eyeing the " + name + "? Grab a tee you own and I'll nail your size.";
    return "Eyeing this one? If you're deciding between sizes, grab a tee you own and I'll sort you.";
  }

  // First-visit cookie heads-up. HONEST, acknowledge-only - it does NOT gate tracking
  // (AU doesn't require consent; if that changes, use Shopify's native consent banner instead).
  function showCookieNotice() {
    cassyGreetingReplaced = true;
    var greetingEl = messagesEl.querySelector('.cassy-msg.from-cassy');
    var bubble = greetingEl || document.createElement('div');
    bubble.className = 'cassy-msg from-cassy';
    bubble.textContent = '';
    var line = document.createElement('div');
    line.textContent = "G'day! Quick heads up, like pretty much every site these days, we use cookies to keep the shop running and see what the crew's into. All good?";
    line.style.marginBottom = '10px';
    bubble.appendChild(line);
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;align-items:center;gap:10px;flex-wrap:wrap;';

    var accept = document.createElement('button');
    accept.textContent = 'Righto';
    accept.style.cssText = 'background:#F16028;color:#FEFCF0;border:none;border-radius:16px;padding:7px 18px;font-size:12px;font-weight:700;cursor:pointer;font-family:inherit;';

    var optout = document.createElement('button');
    optout.textContent = 'No tracking, thanks';
    optout.style.cssText = 'background:transparent;color:#FEFCF0;border:1px solid #7B8C6E;border-radius:16px;padding:7px 14px;font-size:12px;font-weight:600;cursor:pointer;font-family:inherit;';

    var moreInfo = document.createElement('a');
    moreInfo.href = '/policies/privacy-policy';
    moreInfo.target = '_blank';
    moreInfo.rel = 'noopener';
    moreInfo.textContent = 'How we use them';
    moreInfo.style.cssText = 'color:#DDC7A0;font-size:11px;text-decoration:underline;margin-left:2px;';

    row.appendChild(accept);
    row.appendChild(optout);
    row.appendChild(moreInfo);
    bubble.appendChild(row);
    if (!greetingEl) messagesEl.appendChild(bubble);

    function finishCookie(optedOut) {
      try { localStorage.setItem('cassyCookieAck', '1'); } catch (e) {}
      row.remove();
      if (typeof gtag !== 'undefined') gtag('event', optedOut ? 'cassy_cookie_optout' : 'cassy_cookie_ack', { event_category: 'engagement' });
      if (optedOut) addMessage("No worries, I've switched off the tracking cookies for you. The shop still works as normal.", 'from-cassy');
      cassyCookieHelpFollowup();
    }

    accept.onclick = function(){ finishCookie(false); };
    optout.onclick = function(){ cassySetTrackingOff(); finishCookie(true); };
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  // Genuinely opt the visitor out of analytics/marketing tracking via Shopify's consent API.
  // This is real: Shopify gates the GA/Meta channels off this consent state going forward.
  function cassySetTrackingOff() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || typeof cp.setTrackingConsent !== 'function') return;
      var granular = false;
      try { granular = !!(cp.doesMerchantSupportGranularConsent && cp.doesMerchantSupportGranularConsent()); } catch (e) {}
      var consent = granular ? { analytics: false, marketing: false, preferences: false, sale_of_data: false } : false;
      cp.setTrackingConsent(consent, function(){});
    } catch (e) {}
  }

  // Page-aware help line shown right after the cookie heads-up is acknowledged.
  function cassyCookieHelpFollowup() {
    var path = (location.pathname || '').toLowerCase();
    var line;
    if (path.indexOf('/products/') > -1) {
      line = "Good on ya. Now, want a hand sorting your size or seeing the other colours for this one?";
    } else if (path.indexOf('found') > -1) {
      line = "Good on ya. Heads up — the Founders Pack sold out, all 100 claimed. Want me to show you the tee range instead?";
    } else if (path.indexOf('/pages/all-tees') > -1 || path.indexOf('/collections/') > -1) {
      line = "Good on ya. Now, tell me your vibe and I'll point you at a design, or sort your size.";
    } else {
      line = "Good on ya. Now, sing out if you want a hand with sizing or picking a design.";
    }
    addMessage(line, 'from-cassy');
  }

  launcher.addEventListener('click', function() {
    try { sessionStorage.setItem('cassyAutoOpened', '1'); } catch (e) {}
    if (cassyWindow.classList.contains('open')) {
      cassyWindow.classList.remove('open');
    } else {
      openCassy(false);
    }
    cassySaveState();
  });

  closeBtn.addEventListener('click', function() {
    try { sessionStorage.setItem('cassyAutoOpened', '1'); } catch (e) {}
    cassyWindow.classList.remove('open');
    cassySaveState();
  });

  // --- Per-session memory: keep the conversation across page navigations (same tab).
  //     sessionStorage survives navigation and clears when the tab closes. ---
  function cassySaveState() {
    try {
      sessionStorage.setItem('cassyConversation', JSON.stringify({
        history: conversationHistory,
        open: cassyWindow.classList.contains('open')
      }));
    } catch (e) {}
  }

  function cassyRestoreState() {
    var saved = null;
    try { saved = JSON.parse(sessionStorage.getItem('cassyConversation') || 'null'); } catch (e) {}
    if (!saved || !saved.history || !saved.history.length) return;
    conversationHistory = saved.history;
    cassyGreetingReplaced = true;
    messagesEl.innerHTML = '';                 // drop the default greeting, re-render the saved chat
    suggestionsEl.style.display = 'none';
    for (var i = 0; i < conversationHistory.length; i++) {
      addMessage(conversationHistory[i].content, conversationHistory[i].role === 'user' ? 'from-user' : 'from-cassy');
    }
    try { sessionStorage.setItem('cassyAutoOpened', '1'); } catch (e) {}  // don't auto-open over a restored chat
    if (saved.open) { cassyWindow.classList.add('open'); launcher.classList.remove('pulse'); }
  }

  cassyRestoreState();
  window.addEventListener('pagehide', cassySaveState);  // capture final state before navigating away

  document.querySelectorAll('.cassy-suggestion').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.getAttribute('data-cassy-signup') === '1') { offerSignup('chip'); return; }
      sendMessage(btn.textContent);
      suggestionsEl.style.display = 'none';
    });
  });

  inputEl.addEventListener('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); }
  });

  sendBtn.addEventListener('click', handleSend);

  function handleSend() {
    const text = inputEl.value.trim();
    if (!text || isTyping) return;
    if (cassyAwaitingEmail) { inputEl.value = ''; handleEmailEntry(text); return; }
    suggestionsEl.style.display = 'none';
    sendMessage(text);
    inputEl.value = '';
  }

  // ===== Weekly Dump signup (email capture straight into Klaviyo) =====
  // Desktop: offered on exit-intent. All devices: the "Join the Weekly Dump" chip.
  // Emails go into Klaviyo list Tqse8n via the public client API - no secret key needed.
  var CASSY_KLAVIYO_COMPANY_ID = 'RAyLxc';
  var CASSY_KLAVIYO_LIST_ID = 'Tqse8n';

  // Arm exit-intent only after a few seconds, so an early mouse-flick doesn't trigger it.
  setTimeout(function(){ cassyExitArmed = true; }, 8000);

  // Desktop exit-intent: the mouse leaves the top of the window.
  if (window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    document.addEventListener('mouseout', function(e){
      if (!cassyExitArmed) return;
      if (e.clientY <= 0 && !e.relatedTarget) offerSignup('exit');
    });
  }

  function offerSignup(source) {
    try { if (localStorage.getItem('cassySignupDone')) return; } catch (e) {}  // already subscribed
    if (cassyAwaitingEmail) return;                                            // already collecting
    if (source === 'exit') {
      if (cassySignupOffered) return;                 // only auto-offer once per session
      if (cassyKlaviyoOpen) return;                   // a Klaviyo popup is up - don't stack
      if (conversationHistory.length > 0) return;     // don't hijack an active chat
    }
    cassySignupOffered = true;
    if (!cassyWindow.classList.contains('open')) { cassyWindow.classList.add('open'); launcher.classList.remove('pulse'); }
    suggestionsEl.style.display = 'none';
    var cassyPitch = "Before you hit the road, fancy joining the Weekly Dump? A newsletter with a bit of caravanning nonsense, first dibs on new drops, no spam. Pop your email in below and you're on the list.";
    var greetingEl = (!cassyGreetingReplaced && conversationHistory.length === 0) ? messagesEl.querySelector('.cassy-msg.from-cassy') : null;
    if (greetingEl) { greetingEl.textContent = cassyPitch; cassyGreetingReplaced = true; }  // clean single message
    else { addMessage(cassyPitch, 'from-cassy'); }                                          // otherwise append
    cassyAwaitingEmail = true;
    inputEl.placeholder = 'Your email...';
    inputEl.focus();
    if (typeof gtag !== 'undefined') gtag('event', 'cassy_signup_offered', { event_category: 'engagement', event_label: source });
  }

  async function handleEmailEntry(text) {
    var email = (text || '').trim();
    addMessage(email, 'from-user');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      addMessage("Hmm, that doesn't look like an email. Mind trying again?", 'from-cassy');
      return;  // stay in email mode
    }
    cassyAwaitingEmail = false;
    inputEl.placeholder = 'Ask Cassy anything...';
    var typingEl = addTypingIndicator();
    var ok = await cassySubscribe(email);
    typingEl.remove();
    if (ok) {
      try { localStorage.setItem('cassySignupDone', '1'); } catch (e) {}
      addMessage("You're on the list, welcome aboard. Keep an eye out for the next Weekly Dump.", 'from-cassy');
      if (typeof gtag !== 'undefined') gtag('event', 'cassy_signup_completed', { event_category: 'conversion' });
      cassyContextualFollowup();   // dynamic, page-aware "anything else?" offer
    } else {
      addMessage("Ah, something went sideways signing you up. Give it another crack in a sec or email support@thecassettecrew.com.au and we'll sort it.", 'from-cassy');
    }
  }

  async function cassySubscribe(email) {
    try {
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Captain Cassy chat',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: CASSY_KLAVIYO_LIST_ID } } }
        }
      };
      var res = await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CASSY_KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
        body: JSON.stringify(body)
      });
      return res.status === 202 || res.ok;
    } catch (e) { return false; }
  }

  // After a signup, generate ONE short page-aware "anything else?" line via the AI.
  // The static welcome line always shows first; this is the smart tail on top of it.
  async function cassyContextualFollowup() {
    try {
      var pm = (location.pathname || '').match(/\/products\/([^\/?]+)/);
      var og = document.querySelector('meta[property="og:title"]');
      var productName = (og && og.content) ? og.content.split(/\s[|–—-]\s/)[0].trim() : '';
      var ctx = (pm && productName)
        ? 'They are currently on the product page for the "' + productName + '".'
        : 'They are browsing the site (page path: ' + (location.pathname || '/') + ').';
      var instruction = 'INTERNAL INSTRUCTION (not from a customer): The customer just signed up to the Weekly Dump newsletter through you, and they were about to LEAVE the site. '
        + ctx + ' Your goal now is to give them a warm reason to STAY and keep looking around, not to send them on their way. '
        + 'Reply with ONE short, inviting sentence in your voice that offers something genuinely useful right now, for example a hand with sizing for the product they are viewing, or to show them the range. '
        + 'Do NOT use farewell phrasing like "before you go", "before you head off", or "anything else". Do not mention the newsletter again. One sentence only. No markers, no lists.';

      var typingEl = addTypingIndicator();
      var res = await fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'claude-sonnet-4-5',
          max_tokens: 200,
          system: SYSTEM_PROMPT,
          messages: [{ role: 'user', content: instruction }]
        })
      });
      var data = await res.json();
      typingEl.remove();
      var line = (data.content && data.content[0] && data.content[0].text) ? data.content[0].text : '';
      line = line.replace(/\[\[[^\]]*\]\]/g, '').replace(/\*\*/g, '').replace(/\s*[—–]\s*/g, ', ').trim();
      if (line) {
        addMessage(line, 'from-cassy');
        conversationHistory.push({ role: 'assistant', content: line });
      }
    } catch (e) { /* silent: the welcome line already showed */ }
  }

  // Turn URLs, the store domain and the support email in a message into clickable links.
  // Builds real DOM nodes (never innerHTML) so AI/customer text can't inject markup.
  function cassyLinkify(text) {
    var frag = document.createDocumentFragment();
    var re = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)|([\w.+-]+@[\w.-]+\.\w{2,})|((?:https?:\/\/|www\.)[^\s<]+|(?:https?:\/\/)?(?:www\.)?thecassettecrew\.com\.au(?:\/[^\s<]*)?)/gi;
    var last = 0, m;
    while ((m = re.exec(text)) !== null) {
      if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = document.createElement('a');
      a.rel = 'noopener noreferrer';                        // no target=_blank: links open in the same window
      a.style.cssText = 'color:#DDC7A0;text-decoration:underline;font-weight:600;word-break:break-word;';
      if (m[1] && m[2]) {                                   // [label](url)
        a.href = m[2]; a.textContent = m[1];
        frag.appendChild(a);
      } else if (m[3]) {                                    // email
        a.href = 'mailto:' + m[3]; a.textContent = m[3];
        frag.appendChild(a);
      } else if (m[4]) {                                    // raw URL or bare store domain
        var raw = m[4], trail = '';
        var mt = raw.match(/[.,;:!?)\]}'"]+$/);            // don't swallow trailing punctuation
        if (mt) { trail = mt[0]; raw = raw.slice(0, -trail.length); }
        a.href = /^https?:\/\//i.test(raw) ? raw : ('https://' + raw.replace(/^\/+/, ''));
        a.textContent = raw;
        frag.appendChild(a);
        if (trail) frag.appendChild(document.createTextNode(trail));
      }
      last = re.lastIndex;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    return frag;
  }

  function addMessage(text, role) {
    var div = document.createElement('div');
    div.className = 'cassy-msg ' + role;
    div.appendChild(cassyLinkify(text));
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return div;
  }

  function addTypingIndicator() {
    var div = document.createElement('div');
    div.className = 'cassy-msg typing';
    div.id = 'cassy-typing-indicator';
    div.innerHTML = '<div class="cassy-typing-dots"><span></span><span></span><span></span></div>';
    messagesEl.appendChild(div);
    messagesEl.scrollTop = messagesEl.scrollHeight;
    return div;
  }

  async function cassyAddToCart(handle, colour, size) {
    try {
      var res = await fetch('/products/' + handle + '.js');
      if (!res.ok) throw new Error('product fetch failed');
      var product = await res.json();
      var norm = function(s){ return (s || '').trim().toLowerCase(); };
      var variant = product.variants.find(function(v){
        return norm(v.option1) === norm(colour) && norm(v.option2) === norm(size);
      });
      if (!variant) return { ok: false, reason: 'notfound' };
      if (!variant.available) return { ok: false, reason: 'soldout', title: product.title };
      var add = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
      });
      if (!add.ok) throw new Error('add failed');
      return { ok: true, title: product.title };
    } catch (e) {
      return { ok: false, reason: 'error' };
    }
  }

  function addCartConfirmation(title, colour, size) {
    var wrap = document.createElement('div');
    wrap.className = 'cassy-msg from-cassy';
    var line = document.createElement('div');
    line.textContent = '🛒 In your cart: ' + title + ' in ' + colour + ', ' + size;
    line.style.marginBottom = '9px';
    wrap.appendChild(line);
    var row = document.createElement('div');
    row.style.cssText = 'display:flex;gap:8px;';
    var view = document.createElement('a');
    view.href = '/cart';
    view.textContent = 'View cart';
    view.style.cssText = 'flex:1;text-align:center;text-decoration:none;background:#FEFCF0;color:#053D2A;border-radius:16px;padding:7px 10px;font-size:12px;font-weight:700;';
    var checkout = document.createElement('a');
    checkout.href = '/checkout';
    checkout.textContent = 'Checkout';
    checkout.style.cssText = 'flex:1;text-align:center;text-decoration:none;background:#F16028;color:#FEFCF0;border-radius:16px;padding:7px 10px;font-size:12px;font-weight:700;';
    row.appendChild(view);
    row.appendChild(checkout);
    wrap.appendChild(row);
    messagesEl.appendChild(wrap);
    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  var CASSY_COLOUR_HEX = {
    'black':'#1a1a1a','bone':'#E4DAC4','natural':'#EFE9D8','sage':'#9CAF88',
    'forest green':'#123524','army':'#4B5320'
  };

  function cassySizedImg(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }

  async function addGallery(handles) {
    var scroller = document.createElement('div');
    scroller.style.cssText = 'display:flex;gap:10px;overflow-x:auto;overflow-y:hidden;padding:2px 2px 8px;flex-shrink:0;-webkit-overflow-scrolling:touch;';
    messagesEl.appendChild(scroller);

    var products = await Promise.all(handles.map(function(h){
      return fetch('/products/' + h + '.js')
        .then(function(r){ return r.ok ? r.json() : null; })
        .catch(function(){ return null; });
    }));

    products.forEach(function(p, idx){
      if (!p) return;
      var handle = handles[idx];

      var card = document.createElement('div');
      card.style.cssText = 'flex:0 0 150px;background:#fff;border:1px solid #DDC7A0;border-radius:12px;overflow:hidden;display:flex;flex-direction:column;';

      var img = document.createElement('img');
      var mainSrc = p.featured_image || (p.images && p.images[0]) || '';
      img.src = cassySizedImg(mainSrc, 400);
      img.style.cssText = 'width:100%;height:150px;object-fit:cover;display:block;background:#f4f1e6;';
      card.appendChild(img);

      var body = document.createElement('div');
      body.style.cssText = 'padding:8px 9px 10px;flex:1;display:flex;flex-direction:column;';

      var name = document.createElement('div');
      name.textContent = p.title;
      name.style.cssText = 'font-size:12px;font-weight:700;color:#053D2A;line-height:1.25;';
      body.appendChild(name);

      var price = document.createElement('div');
      price.textContent = '$' + Math.round(p.price / 100) + ' AUD';
      price.style.cssText = 'font-size:11px;color:#7B8C6E;margin:auto 0 7px;';
      body.appendChild(price);

      var colours = [], colourImg = {};
      p.variants.forEach(function(v){
        if (v.option1 && colours.indexOf(v.option1) === -1) {
          colours.push(v.option1);
          if (v.featured_image && v.featured_image.src) colourImg[v.option1] = v.featured_image.src;
        }
      });
      if (colours.length) {
        var sw = document.createElement('div');
        sw.style.cssText = 'display:flex;gap:5px;flex-wrap:wrap;margin-bottom:8px;';
        colours.forEach(function(c){
          var dot = document.createElement('button');
          dot.title = c;
          dot.style.cssText = 'width:18px;height:18px;border-radius:50%;border:1.5px solid #DDC7A0;cursor:pointer;padding:0;background:' + (CASSY_COLOUR_HEX[c.toLowerCase()] || '#ccc') + ';';
          dot.onclick = function(){ if (colourImg[c]) img.src = cassySizedImg(colourImg[c], 400); };
          sw.appendChild(dot);
        });
        body.appendChild(sw);
      }

      var view = document.createElement('a');
      view.href = '/products/' + handle;
      view.textContent = 'View';
      view.style.cssText = 'display:block;text-align:center;text-decoration:none;background:#F16028;color:#FEFCF0;border-radius:14px;padding:6px;font-size:11px;font-weight:700;';
      body.appendChild(view);

      card.appendChild(body);
      scroller.appendChild(card);
    });

    messagesEl.scrollTop = messagesEl.scrollHeight;
  }

  async function cassyResolveGroups(rawList) {
    var tokenCollections = {
      'alltees':    { url: '/collections/featured/products.json?limit=250', type: 'T-Shirt' },
      'allhoodies': { url: '/collections/hoodies/products.json?limit=250', type: 'Hoodies' },
      'allcrews':   { url: '/collections/womans-crew-sweaters/products.json?limit=250', type: 'Sweater' }
    };
    var groups = [];
    var misc = [];
    for (var i = 0; i < rawList.length; i++) {
      var tc = tokenCollections[rawList[i].toLowerCase()];
      if (tc) {
        if (misc.length) { groups.push(misc); misc = []; }
        var handles = [];
        try {
          var res = await fetch(tc.url);
          var data = await res.json();
          var prods = data.products || [];
          for (var j = 0; j < prods.length; j++) {
            if (prods[j].product_type === tc.type && handles.indexOf(prods[j].handle) === -1) {
              handles.push(prods[j].handle);
            }
          }
        } catch (e) {}
        if (handles.length) groups.push(handles);
      } else {
        if (misc.indexOf(rawList[i]) === -1) misc.push(rawList[i]);
      }
    }
    if (misc.length) groups.push(misc);
    return groups;
  }

  async function sendMessage(text) {
    if (isTyping) return;
    isTyping = true;
    addMessage(text, 'from-user');
    conversationHistory.push({ role: 'user', content: text });
    if (typeof gtag !== 'undefined') {
      gtag('event', 'cassy_message_sent', { event_category: 'engagement' });
    }
    var typingEl = addTypingIndicator();

    if (conversationHistory.length > 20) {
      conversationHistory = conversationHistory.slice(-20);
    }

    try {
      var response = await fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          model: 'claude-sonnet-4-5',
          max_tokens: 1000,
          system: SYSTEM_PROMPT,
          messages: conversationHistory
        })
      });

      var data = await response.json();
      typingEl.remove();

      var reply = data.content && data.content[0] && data.content[0].text
        ? data.content[0].text
        : "Reckon something went wrong on my end. Flick us an email at support@thecassettecrew.com.au and we'll sort you out.";

      var cartMatch = reply.match(/\[\[ADDTOCART\|([^|]+)\|([^|]+)\|([^\]]+)\]\]/i);
      var displayReply = reply
        .replace(/\[\[ADDTOCART[^\]]*\]\]/gi, '')
        .replace(/\[\[GALLERY[^\]]*\]\]/gi, '')
        .replace(/\*\*/g, '')             // strip stray markdown bold (**) - the chat shows plain text
        .replace(/\s*[—–]\s*/g, ', ')     // no em/en dashes ever reach the customer
        .trim();

      addMessage(displayReply, 'from-cassy');
      conversationHistory.push({ role: 'assistant', content: displayReply });

      var galleryGroups = [];
      var galleryRegex = /\[\[GALLERY\|([^\]]+)\]\]/gi;
      var gMatch;
      while ((gMatch = galleryRegex.exec(reply)) !== null) { galleryGroups.push(gMatch[1]); }
      (async function() {
        for (var k = 0; k < galleryGroups.length; k++) {
          var gRaw = galleryGroups[k].split('|').map(function(s){ return s.trim().split('/').pop(); }).filter(Boolean);
          var groups = await cassyResolveGroups(gRaw);
          for (var g = 0; g < groups.length; g++) {
            if (groups[g].length) await addGallery(groups[g]);
          }
        }
      })();

      if (cartMatch) {
        var handle = cartMatch[1].trim().split('/').pop();
        var colour = cartMatch[2].trim();
        var size = cartMatch[3].trim();
        var result = await cassyAddToCart(handle, colour, size);
        if (result.ok) {
          addCartConfirmation(result.title, colour, size);
        } else if (result.reason === 'soldout') {
          addMessage("Ah, that one's just sold out in that size. Want me to check another size or colour?", 'from-cassy');
        } else {
          addMessage("Couldn't drop that in your cart automatically, but you can grab it here: thecassettecrew.com.au/products/" + handle, 'from-cassy');
        }
      }

    } catch (err) {
      typingEl.remove();
      addMessage("Lost signal out here, try again or email support@thecassettecrew.com.au.", 'from-cassy');
    }

    isTyping = false;
    cassySaveState();   // persist the conversation so it survives page navigation
  }
})();